export const CODE_COPY = {
  INVALID_EMAIL: "Please enter a valid email address.",
  TRIAL_ALREADY_USED: "That email already used a plan. Try signing in instead.",
  RATE_LIMITED: "Too many attempts. Please try again in a few minutes.",
  EMAIL_SEND_FAILED: "We created your trial but couldn’t send the email. Try again shortly.",
  FIREBASE_UNAVAILABLE: "Service is busy. Please try again shortly.",
  DB_READ_FAILED: "We couldn’t start the trial just now. Please try again.",
  DB_WRITE_FAILED: "We couldn’t start the trial just now. Please try again.",
  USER_CREATION_FAILED: "We couldn’t start the trial. Please try again.",
  USER_UPDATE_FAILED: "We couldn’t start the trial. Please try again.",
  USER_LOOKUP_FAILED: "We couldn’t start the trial. Please try again.",
  TOKEN_CREATE_FAILED: "We couldn’t start the trial. Please try again.",
  HTTP_ERROR: "Request could not be processed.",
  UNKNOWN: "Something went wrong. Please try again in a minute.",
  NETWORK_OR_UNKNOWN: "Network issue. Please try again.",
};

export function friendlyCopy(code, fallback) {
  if (code && CODE_COPY[code]) return CODE_COPY[code];
  return fallback || CODE_COPY.UNKNOWN;
}